<template>
  <div class="content c895">
    <h2>
      Hladilnik 1
      <!-- Generiraj v backendu -->
    </h2>
  </div>
  <div class="content c590">
    <!-- pop up za izbris naprave -->
    <div class="popup popDev1" style="display: none">
      <div class="inner">
        <h3>Ali ste prepričani, da želite izbrisati napravo?</h3>
        <div class="msg">
          <h3>Hladilnik</h3>
        </div>
        <div class="con">
          <p>
            Izbrišite napravo, če ste se zmotili pri njenih podatkih oziroma ste
            izbrali napačno napravo. Če bi želeli, jo lahko kasneje brez težav
            ponovno dodate.
          </p>
        </div>
        <div class="btns">
          <a
            href="javascript:void(0)"
            class="btn"
            title="Več"
            onclick="popupDelete('popDev1')"
          >NE, PREKLIČI</a>
          <a class="btn">DA, IZBRIŠI</a>
        </div>
      </div>
    </div>
    <div class="appliance">
      <table>
        <tbody>
          <tr>
            <td class="first">Hladilnik</td>
            <td>85 cm - 156 l hladilnika</td>
            <!-- Izpisi iz objekta -->
            <td>A+++ (po 2002)</td>
            <!-- Izpisi iz objekta -->
            <td class="last">
              <div class="tools">
                <a title="Zbriši" class="close" onclick="popupDelete('popDev1')">Zbriši</a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="appliance data">
      <div class="icon">
        <span class="H">Hladilnik</span>
      </div>
      <div class="first">
        <h5>TRENUTNA PORABA</h5>
        <span>
          <span class="et">
            58,80 kWh / leto
            <!-- Izpisi iz objekta -->
            <div class="tooltip-bottom">
              Enotna tarifa (ET) je tarifa, ki jo beleži enotarifni števec vsak
              dan od 0.00 do 24.00 ure. Cena električne energije je ves čas
              enaka. V primeru, da imate enotarifno merjenje in želite
              dvotarifnega, pokličite v vaše elektrodistribucijsko podjetje za
              podrobnejše informacije.
              <br />
              <a
                href="http://www.uresnicujmo.si/o_aplikaciji_za_izracun_prihrankov/predstavitev#tarife"
                target="_blank"
                title="Več"
              >Več o tem &gt;</a>
            </div>
          </span>
        </span>
        <em>
          <span>4,44 € / leto</span>
          <!-- Izpisi iz objekta -->
        </em>
      </div>

      <div class="no-data">
        <h5>VAŠI PRIHRANKI</h5>
        <h5>VAŠA NOVA PORABA</h5>
        <div class="message">
          <p>
            Za izračun nove porabe in prihrankov na izbrani napravi izvedi vsaj
            en ukrep.
          </p>
        </div>
      </div>
    </div>
    <div class="actions">
      <div class="toggle-btn" style="display: none">
        <a href="javascript:void(0)" class="active">Prihranki zaradi izvedenih ukrepov</a>
      </div>
      <ul class="actionsExistingUl"></ul>

      <h3>Zmanjšajte porabo naprave Hladilnik</h3>
      <p>
        Zmanjšajte porabo tako, da izvedete vsaj enega, še bolje pa več, spodaj
        navedenih ukrepov. Izberite le tiste, ki so v vaših razmerah pomembni.
      </p>
      <ul>
        <li id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl00_divAction">
          <a class="actionBtnMore active" style="cursor: pointer">
            Zamenjajmo naš stari hladilnik z novim, ki je manjši in/ali
            energetsko bolj učinkovit.
          </a>

          <div style="display: block" class="actionPnlMore">
            <div id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl00_PanelNewCooler">
              <div class="form">
                <h3>Izberite lastnosti novega Hladilnika:</h3>
                <fieldset>
                  <div class="f-item select">
                    <label for="type">Tip Hladilnika:</label>
                    <table id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl00_rblType" border="0">
                      <tbody>
                        <tr>
                          <td>
                            <input
                              id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl00_rblType_0"
                              type="radio"
                              name="ctl00$ContentPlaceHolder1$RepeaterActions$ctl00$rblType"
                              value="1"
                              checked="checked"
                            />
                            <label
                              for="ctl00_ContentPlaceHolder1_RepeaterActions_ctl00_rblType_0"
                            >Hladilnik</label>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <input
                              id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl00_rblType_1"
                              type="radio"
                              name="ctl00$ContentPlaceHolder1$RepeaterActions$ctl00$rblType"
                              value="2"
                              onclick="javascript:setTimeout('__doPostBack(\'ctl00$ContentPlaceHolder1$RepeaterActions$ctl00$rblType$1\',\'\')', 0)"
                            />
                            <label for="ctl00_ContentPlaceHolder1_RepeaterActions_ctl00_rblType_1">
                              Kombinirani hladilnik
                              <span>(hladilnik in zmrzovalnik)</span>
                            </label>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="f-item select">
                    <label for="volume">
                      Prostornina:
                      <span>(oz. višina)</span>
                    </label>
                    <span
                      id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl00_RequiredFieldValidator6"
                      style="
                        color: Red;
                        float: none;
                        font-size: 1em;
                        visibility: hidden;
                      "
                    >*</span>
                    <select
                      name="ctl00$ContentPlaceHolder1$RepeaterActions$ctl00$ddlSizeCooler"
                      id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl00_ddlSizeCooler"
                    >
                      <option value="25">85 cm - 156 l hladilnika</option>
                      <option value="24">125 cm - 217 l hladilnika</option>
                      <option value="23">144 cm - 284 l hladilnika</option>
                      <option value="22">180 cm - 346 l hladilnika</option>
                      <option value="21">180 cm - 388 l hladilnika</option>
                    </select>
                    <div class="help">
                      <a href="#" class="help" title="Help"></a>
                      <div class="tooltip">
                        Izberite ustrezno kombinacijo višine in prostornine
                        hladilnika.
                      </div>
                    </div>
                  </div>
                  <div class="f-item select">
                    <label for="class">
                      Energijski razred:
                      <span>(oz. leto izdelave naprave)</span>
                    </label>
                    <span
                      id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl00_RequiredFieldValidator7"
                      style="
                        color: Red;
                        float: none;
                        font-size: 1em;
                        visibility: hidden;
                      "
                    >*</span>
                    <select
                      name="ctl00$ContentPlaceHolder1$RepeaterActions$ctl00$ddlClassCooler"
                      id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl00_ddlClassCooler"
                    >
                      <option value="26">A+++ (po 2002)</option>
                      <option value="27">A++ (po 2002)</option>
                      <option value="28">A+ (po 2002)</option>
                      <option value="29">A (po 2002)</option>
                      <option value="30">B (1996-2002)</option>
                      <option value="31">C (1992-1995)</option>
                      <option value="32">D (pred 1992)</option>
                      <option value="33">E (pred 1992)</option>
                    </select>
                    <div class="help">
                      <a href="#" class="help" title="Help">Help</a>
                      <div class="tooltip">
                        Če ne poznate energijskega razreda hladilnika, lahko
                        glede na leto nakupa določite približen energijski
                        razred. Pred določenim letom namreč aparatov nekaterih
                        energijskih razredov še niso proizvajali.
                        <p></p>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>
            </div>
            <div class="advice">
              <div class="right">
                <a id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl00_lnkBtnAdd" class="btn">
                  <!-- update objekt -->
                  Izvedi ukrep
                </a>
              </div>
              <p>
                Na porabo hladilnika primarno vplivata njegova velikost, še
                posebej velikost zamrzovalnega dela ter energijska učinkovitost.
                Če je naš hladilnik star, nam povzroča težave, ali pa je
                prevelik za naše potrebe, je priporočljivo, da kupimo novega, ki
                je ustrezne velikosti in ima čim boljši energijski razred (A++
                ali A+++). S tem bomo povečali prihranke na tej napravi.
              </p>
            </div>
          </div>
        </li>

        <li id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl01_divAction">
          <a class="actionBtnMore" style="cursor: pointer">
            Preverimo in po potrebi povečajmo nastavitev temperature hlajenja v
            hladilniku
          </a>

          <div style="display: none" class="actionPnlMore">
            <div class="advice">
              <div class="right">
                <a
                  id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl01_lnkBtnAdd"
                  class="btn"
                  href="javascript:__doPostBack('ctl00$ContentPlaceHolder1$RepeaterActions$ctl01$lnkBtnAdd','')"
                >Izvedi ukrep</a>
              </div>
              <p>
                Na porabo hladilnika vpliva tudi sprememba nastavitve za 3 °C do
                5 °C. Zato se prepričajmo, da hladilna temperatura ni prenizka
                (+5 °C do + 6 °C; za občutljiva živila kot so ribe ali mleto
                meso: + 4 °C).
              </p>
            </div>
          </div>
        </li>

        <li id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl02_divAction">
          <a class="actionBtnMore" style="cursor: pointer">Prerazporedimo živila v hladilniku</a>

          <div style="display: none" class="actionPnlMore">
            <div class="advice">
              <div class="right">
                <a
                  id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl02_lnkBtnAdd"
                  class="btn"
                  href="javascript:__doPostBack('ctl00$ContentPlaceHolder1$RepeaterActions$ctl02$lnkBtnAdd','')"
                >Izvedi ukrep</a>
              </div>
              <p>
                Če živila v hladilniku pravilno razporedimo (meso in ribe bliže
                izparilniku, mlečne izdelke v sredino, sadje in zelenjavo na
                dno), lahko hladilnik brez skrbi nastavimo na višjo temperaturo
                in tako zmanjšamo porabo električne energije za do 10%.
              </p>
            </div>
          </div>
        </li>

        <li id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl03_divAction">
          <a class="actionBtnMore" style="cursor: pointer">Postavimo hladilnik v hladnejši prostor</a>

          <div style="display: none" class="actionPnlMore">
            <div class="advice">
              <div class="right">
                <a
                  id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl03_lnkBtnAdd"
                  class="btn"
                  href="javascript:__doPostBack('ctl00$ContentPlaceHolder1$RepeaterActions$ctl03$lnkBtnAdd','')"
                >Izvedi ukrep</a>
              </div>
              <p>
                S pravilno postavitvijo hladilnika v prostor bomo prihranili kar
                nekaj kWh električne energije. Hladilnika ne postavljamo v
                neposredno bližino štedilnika, pečice, radiatorja, pomivalnega
                stroja ali ga ne izpostavljamo sončnim žarkom, saj s tem
                povečamo oddajanja toplote, kar vpliva tudi na višjo porabo
                električne energije.
              </p>
            </div>
          </div>
        </li>

        <li id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl04_divAction">
          <a class="actionBtnMore" style="cursor: pointer">Hladilnik izklopimo ali povsem odstranimo</a>

          <div style="display: none" class="actionPnlMore">
            <div class="advice">
              <div class="right">
                <a
                  id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl04_lnkBtnAdd"
                  class="btn"
                  href="javascript:__doPostBack('ctl00$ContentPlaceHolder1$RepeaterActions$ctl04$lnkBtnAdd','')"
                >Izvedi ukrep</a>
              </div>
              <p>
                Če se odpravljate na daljši dopust je smiselno hladilnik
                izprazniti ali izklopiti, kakor tudi, kadar imate v
                gospodinjstvu več hladilnikov, ki jih v bistvu ne potrebujete. Z
                izklopom boste znatno znižali porabo električne energije.
              </p>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="advice">
      <h4>Imejte vedno v mislih, da lahko prihranite!</h4>
      <p>
        Zgornji ukrepi so merljivi in ob njihovem izvajanju točno veste, koliko
        energije lahko prihranite. Toda za vse električne naprave v
        gospodinjstvu, tako večje kot majhne, smo zbrali še kopico nasvetov, ki
        vam lahko pomagajo dodatno prihraniti, čeprav prihranka zaradi
        različnosti naprav in situacij za te nasvete ni mogoče količinsko
        opredeliti.
      </p>
      <a
        href="http://www.uresnicujmo.si/nasveti/hladilnik"
        target="_blank"
        alt="več"
        class="more"
      >PREBERITE NASVETE</a>
    </div>
  </div>
  <div class="content r-c">
    <div class="c282">
      <h3>PORABA NAPRAVE HLADILNIK 1</h3>
      <div class="select">
        <select
          name="ctl00$ContentPlaceHolder1$ddlUsageType"
          onchange="javascript:setTimeout('__doPostBack(\'ctl00$ContentPlaceHolder1$ddlUsageType\',\'\')', 0)"
          id="ctl00_ContentPlaceHolder1_ddlUsageType"
          class="s156"
        >
          <option selected="selected" value="1">Kumulativna poraba (€)</option>
          <option value="2">Kumulativna poraba (kWh)</option>
        </select>
        <select
          name="ctl00$ContentPlaceHolder1$ddlUsageTSpan"
          onchange="javascript:setTimeout('__doPostBack(\'ctl00$ContentPlaceHolder1$ddlUsageTSpan\',\'\')', 0)"
          id="ctl00_ContentPlaceHolder1_ddlUsageTSpan"
        >
          <option selected="selected" value="1">za 1 leto</option>
          <option value="5">za 5 let</option>
          <option value="10">za 10 let</option>
          <option value="15">za 15 let</option>
        </select>
      </div>

      <div class="graph">
        <div class="chart">
          <div
            id="ctl00_ContentPlaceHolder1_divCurrentUsage"
            class="col without"
            style="height: 100%"
          >
            <span id="ctl00_ContentPlaceHolder1_lblCurrentUsage">4,44 €</span>
          </div>
        </div>
        <div class="legend">
          <div class="col">
            <strong>Poraba brez</strong> izvedenih ukrepov
          </div>
          <div class="col">
            <strong>Poraba z</strong> izvedenimi ukrepi
          </div>
        </div>
      </div>
    </div>
    <div class="c282">
      <h3>PORABA NAPRAVE HLADILNIK 1</h3>
      <div class="select">
        <select
          name="ctl00$ContentPlaceHolder1$ddlUsageType2"
          onchange="javascript:setTimeout('__doPostBack(\'ctl00$ContentPlaceHolder1$ddlUsageType2\',\'\')', 0)"
          id="ctl00_ContentPlaceHolder1_ddlUsageType2"
          class="s156"
        >
          <option selected="selected" value="1">Kumulativna poraba (€)</option>
          <option value="2">Kumulativna poraba (kWh)</option>
        </select>
        <select
          name="ctl00$ContentPlaceHolder1$ddlUsageTSpan2"
          onchange="javascript:setTimeout('__doPostBack(\'ctl00$ContentPlaceHolder1$ddlUsageTSpan2\',\'\')', 0)"
          id="ctl00_ContentPlaceHolder1_ddlUsageTSpan2"
        >
          <option value="1">za 1 leto</option>
          <option selected="selected" value="5">za 5 let</option>
          <option value="10">za 10 let</option>
          <option value="15">za 15 let</option>
        </select>
      </div>
      <div class="graph image">
        <div class="chart">
          <img
            id="ctl00_ContentPlaceHolder1_Chart1"
            src="/Images/Charts/Chart000008.png?cdf79a89-2545-4f7a-b8fc-99c8e5ae0b08"
            alt
            usemap="#ctl00_ContentPlaceHolder1_Chart1ImageMap"
            style="height: 168px; width: 263px; border-width: 0px; padding: 0"
          />
          <map
            name="ctl00_ContentPlaceHolder1_Chart1ImageMap"
            id="ctl00_ContentPlaceHolder1_Chart1ImageMap"
          >
            <area
              shape="poly"
              coords="198, 144, 198, 47, 198, 47, 257, 23, 257, 23, 257, 144, 198, 144"
              title="13.11.2025; 22,191414"
              alt
            />
            <area
              shape="poly"
              coords="139, 144, 139, 71, 139, 71, 198, 47, 198, 47, 198, 144, 139, 144"
              title="13.11.2024; 17,7531312"
              alt
            />
            <area
              shape="poly"
              coords="81, 144, 81, 95, 81, 95, 139, 71, 139, 71, 139, 144, 81, 144"
              title="13.11.2023; 13,3148484"
              alt
            />
            <area
              shape="poly"
              coords="22, 144, 22, 120, 22, 120, 81, 95, 81, 95, 81, 144, 22, 144"
              title="13.11.2022; 8,8765656"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 23, 257, 23, 22, 120, 22, 120, 22, 144, 257, 144"
              title="13.11.2021; 4,4382828"
              alt
            />
            <area
              shape="poly"
              coords="198, 144, 198, 47, 198, 47, 257, 23, 257, 23, 257, 144, 198, 144"
              title="13.11.2025; 22,191414"
              alt
            />
            <area
              shape="poly"
              coords="139, 144, 139, 71, 139, 71, 198, 47, 198, 47, 198, 144, 139, 144"
              title="13.11.2024; 17,7531312"
              alt
            />
            <area
              shape="poly"
              coords="81, 144, 81, 95, 81, 95, 139, 71, 139, 71, 139, 144, 81, 144"
              title="13.11.2023; 13,3148484"
              alt
            />
            <area
              shape="poly"
              coords="22, 144, 22, 120, 22, 120, 81, 95, 81, 95, 81, 144, 22, 144"
              title="13.11.2022; 8,8765656"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 23, 257, 23, 22, 120, 22, 120, 22, 144, 257, 144"
              title="13.11.2021; 4,4382828"
              alt
            />
            <area
              shape="poly"
              coords="198, 144, 198, 47, 198, 47, 257, 23, 257, 23, 257, 144, 198, 144"
              title="13.11.2025; 22,191414"
              alt
            />
            <area
              shape="poly"
              coords="139, 144, 139, 71, 139, 71, 198, 47, 198, 47, 198, 144, 139, 144"
              title="13.11.2024; 17,7531312"
              alt
            />
            <area
              shape="poly"
              coords="81, 144, 81, 95, 81, 95, 139, 71, 139, 71, 139, 144, 81, 144"
              title="13.11.2023; 13,3148484"
              alt
            />
            <area
              shape="poly"
              coords="22, 144, 22, 120, 22, 120, 81, 95, 81, 95, 81, 144, 22, 144"
              title="13.11.2022; 8,8765656"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 23, 257, 23, 22, 120, 22, 120, 22, 144, 257, 144"
              title="13.11.2021; 4,4382828"
              alt
            />
            <area
              shape="poly"
              coords="198, 144, 198, 47, 198, 47, 257, 23, 257, 23, 257, 144, 198, 144"
              title="13.11.2025; 22,191414"
              alt
            />
            <area
              shape="poly"
              coords="139, 144, 139, 71, 139, 71, 198, 47, 198, 47, 198, 144, 139, 144"
              title="13.11.2024; 17,7531312"
              alt
            />
            <area
              shape="poly"
              coords="81, 144, 81, 95, 81, 95, 139, 71, 139, 71, 139, 144, 81, 144"
              title="13.11.2023; 13,3148484"
              alt
            />
            <area
              shape="poly"
              coords="22, 144, 22, 120, 22, 120, 81, 95, 81, 95, 81, 144, 22, 144"
              title="13.11.2022; 8,8765656"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 23, 257, 23, 22, 120, 22, 120, 22, 144, 257, 144"
              title="13.11.2021; 4,4382828"
              alt
            />
            <area
              shape="poly"
              coords="198, 144, 198, 47, 198, 47, 257, 23, 257, 23, 257, 144, 198, 144"
              title="13.11.2025; 22,191414"
              alt
            />
            <area
              shape="poly"
              coords="139, 144, 139, 71, 139, 71, 198, 47, 198, 47, 198, 144, 139, 144"
              title="13.11.2024; 17,7531312"
              alt
            />
            <area
              shape="poly"
              coords="81, 144, 81, 95, 81, 95, 139, 71, 139, 71, 139, 144, 81, 144"
              title="13.11.2023; 13,3148484"
              alt
            />
            <area
              shape="poly"
              coords="22, 144, 22, 120, 22, 120, 81, 95, 81, 95, 81, 144, 22, 144"
              title="13.11.2022; 8,8765656"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 23, 257, 23, 22, 120, 22, 120, 22, 144, 257, 144"
              title="13.11.2021; 4,4382828"
              alt
            />
            <area
              shape="poly"
              coords="198, 144, 198, 47, 198, 47, 257, 23, 257, 23, 257, 144, 198, 144"
              title="13.11.2025; 22,191414"
              alt
            />
            <area
              shape="poly"
              coords="139, 144, 139, 71, 139, 71, 198, 47, 198, 47, 198, 144, 139, 144"
              title="13.11.2024; 17,7531312"
              alt
            />
            <area
              shape="poly"
              coords="81, 144, 81, 95, 81, 95, 139, 71, 139, 71, 139, 144, 81, 144"
              title="13.11.2023; 13,3148484"
              alt
            />
            <area
              shape="poly"
              coords="22, 144, 22, 120, 22, 120, 81, 95, 81, 95, 81, 144, 22, 144"
              title="13.11.2022; 8,8765656"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 23, 257, 23, 22, 120, 22, 120, 22, 144, 257, 144"
              title="13.11.2021; 4,4382828"
              alt
            />
            <area
              shape="poly"
              coords="198, 144, 198, 47, 198, 47, 257, 23, 257, 23, 257, 144, 198, 144"
              title="13.11.2025; 22,191414"
              alt
            />
            <area
              shape="poly"
              coords="139, 144, 139, 71, 139, 71, 198, 47, 198, 47, 198, 144, 139, 144"
              title="13.11.2024; 17,7531312"
              alt
            />
            <area
              shape="poly"
              coords="81, 144, 81, 95, 81, 95, 139, 71, 139, 71, 139, 144, 81, 144"
              title="13.11.2023; 13,3148484"
              alt
            />
            <area
              shape="poly"
              coords="22, 144, 22, 120, 22, 120, 81, 95, 81, 95, 81, 144, 22, 144"
              title="13.11.2022; 8,8765656"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 23, 257, 23, 22, 120, 22, 120, 22, 144, 257, 144"
              title="13.11.2021; 4,4382828"
              alt
            />
            <area
              shape="poly"
              coords="198, 144, 198, 47, 198, 47, 257, 23, 257, 23, 257, 144, 198, 144"
              title="13.11.2025; 22,191414"
              alt
            />
            <area
              shape="poly"
              coords="139, 144, 139, 71, 139, 71, 198, 47, 198, 47, 198, 144, 139, 144"
              title="13.11.2024; 17,7531312"
              alt
            />
            <area
              shape="poly"
              coords="81, 144, 81, 95, 81, 95, 139, 71, 139, 71, 139, 144, 81, 144"
              title="13.11.2023; 13,3148484"
              alt
            />
            <area
              shape="poly"
              coords="22, 144, 22, 120, 22, 120, 81, 95, 81, 95, 81, 144, 22, 144"
              title="13.11.2022; 8,8765656"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 23, 257, 23, 22, 120, 22, 120, 22, 144, 257, 144"
              title="13.11.2021; 4,4382828"
              alt
            />
            <area
              shape="poly"
              coords="198, 144, 198, 47, 198, 47, 257, 23, 257, 23, 257, 144, 198, 144"
              title="13.11.2025; 22,191414"
              alt
            />
            <area
              shape="poly"
              coords="139, 144, 139, 71, 139, 71, 198, 47, 198, 47, 198, 144, 139, 144"
              title="13.11.2024; 17,7531312"
              alt
            />
            <area
              shape="poly"
              coords="81, 144, 81, 95, 81, 95, 139, 71, 139, 71, 139, 144, 81, 144"
              title="13.11.2023; 13,3148484"
              alt
            />
            <area
              shape="poly"
              coords="22, 144, 22, 120, 22, 120, 81, 95, 81, 95, 81, 144, 22, 144"
              title="13.11.2022; 8,8765656"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 23, 257, 23, 22, 120, 22, 120, 22, 144, 257, 144"
              title="13.11.2021; 4,4382828"
              alt
            />
            <area
              shape="poly"
              coords="198, 144, 198, 47, 198, 47, 257, 23, 257, 23, 257, 144, 198, 144"
              title="13.11.2025; 22,191414"
              alt
            />
            <area
              shape="poly"
              coords="139, 144, 139, 71, 139, 71, 198, 47, 198, 47, 198, 144, 139, 144"
              title="13.11.2024; 17,7531312"
              alt
            />
            <area
              shape="poly"
              coords="81, 144, 81, 95, 81, 95, 139, 71, 139, 71, 139, 144, 81, 144"
              title="13.11.2023; 13,3148484"
              alt
            />
            <area
              shape="poly"
              coords="22, 144, 22, 120, 22, 120, 81, 95, 81, 95, 81, 144, 22, 144"
              title="13.11.2022; 8,8765656"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 23, 257, 23, 22, 120, 22, 120, 22, 144, 257, 144"
              title="13.11.2021; 4,4382828"
              alt
            />
            <area
              shape="poly"
              coords="198, 144, 198, 47, 198, 47, 257, 23, 257, 23, 257, 144, 198, 144"
              title="13.11.2025; 22,191414"
              alt
            />
            <area
              shape="poly"
              coords="139, 144, 139, 71, 139, 71, 198, 47, 198, 47, 198, 144, 139, 144"
              title="13.11.2024; 17,7531312"
              alt
            />
            <area
              shape="poly"
              coords="81, 144, 81, 95, 81, 95, 139, 71, 139, 71, 139, 144, 81, 144"
              title="13.11.2023; 13,3148484"
              alt
            />
            <area
              shape="poly"
              coords="22, 144, 22, 120, 22, 120, 81, 95, 81, 95, 81, 144, 22, 144"
              title="13.11.2022; 8,8765656"
              alt
            />
          </map>
        </div>
        <div class="legend">
          <ul>
            <li class="without">Poraba brez izvedenih ukrepov</li>
            <li class="with">Poraba z izvedenimi ukrepi</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>